module.exports = __webpack_public_path__ + "img/gear-k_70x70.e836c9c0.png";